module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-panel padded"
  }, [_c('agent-form', {
    attrs: {
      "passedForm": _vm.form,
      "isEditAgent": true
    },
    on: {
      "toggleIsDisabled": _vm.toggleIsDisabled,
      "formHaveErros": function($event) {
        return _vm.$emit('formHaveErros', $event)
      },
      "readyToSave": _vm.readyToSave
    }
  }), _vm._v(" "), (_vm.showButtons) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-end"
  }, [_c('div', [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a40f6eb0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a40f6eb0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentEdit.vue
// module id = 1334
// module chunks = 0